import { Ref } from "react";
import CreatorFragmentConfig from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragmentConfig";
import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
import CustomTaskDescriptionCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CustomTaskDescriptionCreatorFragment/CustomTaskDescriptionCreatorFragment";
import SwitchCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/SwitchCreatorFragment/SwitchCreatorFragment";
import AddImagesCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/AddImagesCreatorFragment/AddImagesCreatorFragment";
import TextModalCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/TextModalCreatorFragment/TextModalCreatorFragment";
import AssignToCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/AssignToCreatorFragment/AssignToCreatorFragment";
import InvalidCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/InvalidCreatorFragment/InvalidCreatorFragment";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";
import AttachFilesCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/AttachFilesCreatorFragment/AttachFilesCreatorFragment";

export type CreatorFragmentHandle = {
  valid: boolean;
};

export type CreatorFragmentCommonProps = {
  blockInput: boolean;
  task: Record<string, unknown> | Loading;
  onTaskChange: (part: Record<string, unknown>) => void;
  showValidation: boolean;
};

type CreatorFragmentProps = {
  config: CreatorFragmentConfig;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function CreatorFragment({ config, commonProps, ref }: CreatorFragmentProps) {
  const { id, props: configProps } = config;
  switch (id) {
    case "custom-task-description-creator-fragment": {
      return (
        <CustomTaskDescriptionCreatorFragment
          configProps={configProps}
          commonProps={commonProps}
          ref={ref}
        />
      );
    }
    case "add-images-creator-fragment": {
      return (
        <AddImagesCreatorFragment
          configProps={configProps}
          commonProps={commonProps}
          ref={ref}
        />
      );
    }
    case "text-modal-creator-fragment": {
      return (
        <TextModalCreatorFragment
          configProps={configProps}
          commonProps={commonProps}
          ref={ref}
        />
      );
    }
    case "switch-creator-fragment": {
      return (
        <SwitchCreatorFragment
          configProps={configProps}
          commonProps={commonProps}
          ref={ref}
        />
      );
    }
    case "assign-to-creator-fragment": {
      return (
        <AssignToCreatorFragment
          configProps={configProps}
          commonProps={commonProps}
          ref={ref}
        />
      );
    }
    case "attach-files-creator-fragment": {
      return (
        <AttachFilesCreatorFragment
          configProps={configProps}
          commonProps={commonProps}
          ref={ref}
        />
      );
    }
    default: {
      console.error(`'${id}' does not map to any creator fragment component`);
      reportMessageToSentry(
        `Creator fragment config id does not map to any creator fragment component`,
        {
          id,
        },
        "error"
      );
      return <InvalidCreatorFragment />;
    }
  }
}

export default CreatorFragment;
